import { Stamp } from "lucide-react";

/** Pilihan Save As: tambah tandatangan digital & cop cawangan di hujung PDF. */
export default function SignToggle({ checked, onChange, testid, compact = false }) {
  return (
    <label className={`flex items-center gap-2 cursor-pointer select-none rounded-xl border transition-colors ${checked ? "border-indigo-300 bg-indigo-50" : "border-slate-200 bg-white hover:border-indigo-200"} ${compact ? "px-2 py-1" : "px-3 py-2"}`}
      data-testid={testid}>
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} className="h-3.5 w-3.5 accent-indigo-600" data-testid={`${testid}-input`} />
      <Stamp className={`h-3.5 w-3.5 shrink-0 ${checked ? "text-indigo-600" : "text-slate-400"}`} />
      <span className={`${compact ? "text-[10px]" : "text-[11px]"} font-semibold text-slate-700`}>Tambah tandatangan & cop cawangan</span>
    </label>
  );
}
